import { FileQuestion } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router";
import { Button } from "@altek/ui/components/ui/Button";
import { useScreenTitle } from "@/app/layouts/document-title";

/**
 * «SAYFA BULUNAMADI» — TEK EKRAN, İKİ KAPI (8 Ekim 2026, kullanılabilirlik turu).
 *
 * İki ayrı çizim vardı ve ayrışmıştı: gerçekten olmayan bir adres (`NotFoundPage`) «Başlangıca dön»
 * bağlantısı veriyordu, yetkisi olmayan bir adres (`ProtectedRoute`) aynı cümleyi ÇIKIŞSIZ
 * gösteriyordu. İkisinin de `<h1>`'i yoktu: kitin `EmptyState`'i başlığını bir `<div>` olarak
 * çiziyor, yani ekran okuyucu sayfada tek bir başlık bulamıyordu ve sekme başlığı önceki ekranın
 * adını taşıyordu.
 *
 * AYNI ÇİZİM ŞART, yalnız güzellik için değil: yetkisiz adres «yok» diye cevaplanıyor ki ekranın
 * VAR olduğu söylenmesin (`ProtectedRoute`'un gerekçesi). İki ekran farklı görünseydi fark,
 * saklanan şeyi söylerdi.
 *
 * `EmptyState`'in görünüşü (simge, `text-md` başlık, `42ch` açıklama, tek eylem) aynen korunuyor;
 * tek fark başlığın gerçek bir `<h1>` olması. `RouteErrorPage` de aynı yolu izliyor.
 *
 * NE YAPILACAĞI VE KİME BAŞVURULACAĞI (9 Ekim 2026, 5. tur). Ekran yalnız «yok veya adresi
 * değişmiş» diyordu; kapalı bir modülün ya da yetkinin adresine gelen kişi ne yapacağını
 * bilmiyordu. Cümle üç olasılığı birlikte sayıyor ve sistem yöneticisini adıyla gösteriyor —
 * İKİ KAPIDA AYNI CÜMLE, yani hangi adresin var olduğunu yine söylemiyor. Bir önceki sayfa varsa
 * «Geri dön» da var: uygulama içinden kırık bir bağlantıya basan kişinin en kısa yolu o.
 */
export function NotFoundScreen() {
  useScreenTitle("Sayfa bulunamadı");
  const navigate = useNavigate();
  /** React Router ilk girişe `"default"` anahtarını veriyor: geri gidilecek bir sayfa yok. */
  const canGoBack = useLocation().key !== "default";

  return (
    <div className="grid min-h-[60vh] place-items-center p-6">
      <div className="flex flex-col items-center gap-3 px-6 py-14 text-center">
        <FileQuestion size={28} strokeWidth={1.6} className="text-fg-subtle" aria-hidden="true" />
        <h1 className="text-md font-semibold text-fg">Sayfa bulunamadı</h1>
        <p className="max-w-[42ch] text-sm text-fg-muted">
          Aradığınız sayfa yok, adresi değişmiş ya da size açık değil. Bu sayfaya erişmeniz
          gerekiyorsa sistem yöneticinize başvurun.
        </p>
        <div className="mt-1 flex flex-wrap justify-center gap-2">
          {canGoBack ? (
            <Button variant="secondary" className="max-md:h-11" onClick={() => void navigate(-1)}>
              Geri dön
            </Button>
          ) : null}
          <Button asChild variant="secondary" className="max-md:h-11">
            <Link to="/">Başlangıca dön</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
